import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Layout from "../components/layoutBlack";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { hideLoader } from "../store/slices/loader.ts";

const ChooseCarrier = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const items = useSelector((state) => state.cart.items);
  const subtotal = useSelector((state) => state.cart.subtotal);
  const discountValue = useSelector((state) => state.cart.discount_value);
  const total = useSelector((state) => state.cart.total_price);
  const [combinedTotal, setCombinedTotal] = useState("0.00");
 const shippingAmount_ = parseFloat(combinedTotal) - (parseFloat(subtotal) - parseFloat(discountValue));


  useEffect(() => {
    // hide loader once the page finishes mounting
    dispatch(hideLoader());
  }, [dispatch]);

  const { shippingRates = {}, billingInfo = {}, shippingInfo = {} } = location.state || {};

  // Clone shippingRates deeply to avoid mutating location.state directly
  const adjustedShippingRates = JSON.parse(JSON.stringify(shippingRates.data || {}));

  // If cart total is >= 40, set the *lowest* rate to 0
  if (parseFloat(total) >= 40 && Object.keys(adjustedShippingRates).length > 0 && shippingInfo.country == 'US') {
    let lowestId = null;
    let lowestAmount = Infinity;

    for (const [id, rate] of Object.entries(adjustedShippingRates)) {
      const amount = parseFloat(rate.amount);
      if (amount < lowestAmount) {
        lowestAmount = amount;
        lowestId = id;
      }
    }

    if (lowestId) {
      adjustedShippingRates[lowestId].amount = "0.00"; // or 0 (string ensures consistent display)
    }
  }

 
  const initialValues = { selectedRate: "" };

  const validationSchema = Yup.object({
    selectedRate: Yup.string().required("Please select a shipping option"),
  });

  const handleSubmit = (values) => {
    const selected = adjustedShippingRates[values.selectedRate];
    const rates_id = values.selectedRate;

    navigate("/payment", {
      state: {
        rates_id: rates_id,
        billingInfo,
        shippingInfo,
      },
    });
  };

  return (
    <Layout>
    <section className="full-page-section bg0 p-t-120 p-b-80">
      <div className="container">
        <div className="row isotope-grid">
      <section className="full-page-section bg0 p-t-62 p-b-60">
        <div className="container">
          <div className="row">
            {/* Left Column – Address + Shipping Options */}
            <div className="col-lg-5 mb-5">
              <h4 className="mb-3">Shipping Address</h4>
              <div className="border p-3 rounded mb-3 bg-light">
                <p className="mb-1">
                  <strong>{billingInfo.firstName} {billingInfo.lastName}</strong>
                </p>
                <p className="mb-1">{billingInfo.street1}</p>
                {billingInfo.street2 && <p className="mb-1">{billingInfo.street2}</p>}
                <p className="mb-1">
                  {billingInfo.city}, {billingInfo.state} {billingInfo.zip}
                </p>
                <p className="mb-1">{billingInfo.country}</p>
                <p className="mb-0">{billingInfo.email}</p>
              </div>

              <button
                type="button"
                className="btn btn-outline-secondary mb-4 w-100"
                onClick={() => navigate("/shipping-info")}
              >
                Edit Address
              </button>
              <h4 className="mb-3">Choose Shipping Option</h4>
<Formik
  initialValues={initialValues}
  validationSchema={validationSchema}
  onSubmit={(values) => {
    const selected = adjustedShippingRates[values.selectedRate];
    const rates_id = values.selectedRate;
    const shippingCost = parseFloat(selected.amount);
    const cartTotal = parseFloat(total);
    const grandTotal = (cartTotal + shippingCost).toFixed(2);

    navigate("/payment", {
      state: {
        selectedRate: selected,
        rates_id: rates_id,
        billingInfo,
        shippingInfo,
        cartItems: items,
        total: grandTotal,
      },
    });
  }}
>
  {({ isSubmitting, values, setFieldValue }) => {
    const selected = adjustedShippingRates?.[values.selectedRate];
    const shippingAmount = selected ? parseFloat(selected.amount) : 0;
    const cartTotal = parseFloat(total);
    // const combinedTotal = (cartTotal + shippingAmount).toFixed(2);
    const newTotal = (cartTotal + shippingAmount).toFixed(2);

    // Update combinedTotal state safely during render
    if (newTotal !== combinedTotal) {
      setCombinedTotal(newTotal);
    }

    return (
      <Form>
        <div className="mb-3">
          {Object.entries(adjustedShippingRates || {}).map(([id, rate]) => (
            <div className="form-check mb-2" key={id}>
              <Field
                type="radio"
                name="selectedRate"
                value={id}
                className="form-check-input"
                id={`rate-${id}`}
              />
              <label htmlFor={`rate-${id}`} className="form-check-label">
                {rate.provider} - {rate.service_level} (${rate.amount}) — {rate.estimated_days} day(s)
              </label>
            </div>
          ))}
          <ErrorMessage
            name="selectedRate"
            component="div"
            className="text-danger small mt-1"
          />
        </div>

        <div className="mt-3">
          <strong>Shipping:</strong>{" "}
          {selected ? `$${shippingAmount.toFixed(2)}` : "—"}
        </div>
        <div className="mt-1 mb-3">
          <strong>Total:</strong> ${combinedTotal}
        </div>

        <button
          type="submit"
          className="btn btn-primary w-100"
          disabled={isSubmitting}
        >
          Continue to Payment
        </button>
      </Form>
    );
  }}
</Formik>
            </div>

            {/* Right Column – Cart Summary */}
            <div className="col-lg-7">
              <h4 className="mb-4">Your Cart</h4>
              <div className="table-responsive">
                <table className="table">
                  <thead className="table-light">
                    <tr>
                      <th>Image</th>
                      <th>Product</th>
                      <th>Price</th>
                      <th>Qty</th>
                      <th>Total</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item) => (
                      <tr key={item.id}>
                        <td>
                          <img src={item.image} alt={item.name} style={{ width: "50px" }} />
                        </td>
                        <td>{item.name}</td>
                        <td>${item.price.toFixed(2)}</td>
                        <td>{item.quantity}</td>
                        <td>${(item.price * item.quantity).toFixed(2)}</td>
                        <td>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-between mt-4">
                <div>
                  <div><strong>Subtotal:</strong></div>
                  {parseFloat(discountValue) > 0 && <div><strong>Discount:</strong></div>}
                  <div><strong>Shipping:</strong></div>
                  <div><strong>Total:</strong></div>
                </div>
                <div className="text-end">
                  <div>${parseFloat(subtotal).toFixed(2)}</div>
                  {parseFloat(discountValue) > 0 && (
                    <div className="text-success">– ${parseFloat(discountValue).toFixed(2)}</div>
                  )}
                  <div>${parseFloat(shippingAmount_).toFixed(2)}</div>
                  <div><strong>${combinedTotal}</strong></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      </div>
      </div>
      </section>
    </Layout>
  );
};

export default ChooseCarrier;
